import { IonFooter, IonToolbar, } from '@ionic/vue';
import { Browser } from '@capacitor/browser';
export default {
    name: "AppFooter",
    components: {
        IonFooter,
        IonToolbar
    },
    methods: {
        async openUrl(url) {
            await Browser.open({ url });
        }
    },
    computed: {
        privacyPolicyUrl() {
            return `${process.env.VUE_APP_COCKPIT_URL}/privacy-policy`;
        }
    }
};
